import type { PersonalCenterOption, Settings } from "../../stores/modules/settings/types";

/**
 * 从个人中心 item 中解析 options 列表
 * @param target personalCenter item
 */
export const getPersonalCenterOptions = async (target?: NonNullable<Settings['personalCenter']>[0]) => {
  const emptyList: PersonalCenterOption[] = []
  if (!target) {
    return emptyList
  }

  const { optionsJson, options } = target;
  let tmpOptions: PersonalCenterOption[] | undefined = typeof options === 'function' ? await options() : options;
  if (tmpOptions == null && optionsJson) {
    try {
      tmpOptions = JSON.parse(optionsJson || '[]');
    } catch (e) {
      //
    }
  }
  return tmpOptions || emptyList;
}